import { Shield, Lock, CheckCircle2, Award } from "lucide-react";

export default function TrustBadges() {
  const badges = [
    {
      icon: Shield,
      label: "Secure Platform",
      description: "Bank-level encryption"
    },
    {
      icon: Lock,
      label: "SSL Protected",
      description: "Your data is safe"
    },
    {
      icon: CheckCircle2,
      label: "Licensed Partners",
      description: "UAE regulated providers"
    },
    {
      icon: Award,
      label: "Trusted Marketplace",
      description: "Verified merchants"
    }
  ];

  return (
    <div className="py-8 bg-accent/5 border-y border-border">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {badges.map((badge, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center text-center space-y-2 p-4"
            >
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                <badge.icon className="w-6 h-6 text-primary" />
              </div>
              <div>
                <div className="font-semibold text-sm text-foreground">
                  {badge.label}
                </div>
                <div className="text-xs text-muted-foreground">
                  {badge.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
